import { getIn, useFormikContext } from "formik";
import * as Yup from "yup";
import { Icon, Stack, Typography } from "@mui/material";
import { LucideCircleArrowRight } from "lucide-react";
import Frame from "@/components/Frame";
import InputText from "@/components/InputText";
import { OrganizationWebsite } from "../OrganizationWebsite";
import { useResponsive } from "@/hooks";

export const MetadataSchema = Yup.object().shape({
  title: Yup.string().required("El título es obligatorio").min(2, "El título debe tener al menos 2 caracteres").max(60, "El título no puede tener más de 60 caracteres"),
  description: Yup.string()
    .required("La descripción es obligatoria")
    .min(2, "La descripción debe tener al menos 2 caracteres")
    .max(160, "La descripción no puede tener más de 160 caracteres"),
});

const WebsiteNavigation = () => {
  const { values, errors, touched } = useFormikContext<OrganizationWebsite>();
  const titleLength = values?.metaData?.title?.length || 0;
  const descriptionLength = values?.metaData?.description?.length || 0;

  const { isDesktop } = useResponsive();

  return (
    <Stack direction={isDesktop ? "row" : "column"} spacing={2} alignItems={"center"}>
      <Frame>
        <Stack spacing={2}>
          <Typography variant="h4">Metadatos</Typography>
          <Stack spacing={2}>
            <div>
              <InputText
                label="Título"
                name="metaData.title"
                value={values?.metaData?.title}
                error={Boolean(getIn(touched, "metaData.title") && getIn(errors, "metaData.title"))}
                helperText={getIn(touched, "metaData.title") && getIn(errors, "metaData.title")}
              />
              <Typography variant="caption" color="#00000060" ml={1}>
                {titleLength} / 60 caracteres máximos
              </Typography>
            </div>
            <div>
              <InputText
                label="Título"
                multiline
                rows={3}
                name="metaData.description"
                value={values?.metaData?.description}
                error={Boolean(getIn(touched, "metaData.description") && getIn(errors, "metaData.description"))}
                helperText={getIn(touched, "metaData.description") && getIn(errors, "metaData.description")}
              />
              <Typography variant="caption" color="#00000060" ml={1}>
                {descriptionLength} / 160 caracteres máximos
              </Typography>
            </div>
          </Stack>
        </Stack>
      </Frame>
      <Icon>
        <LucideCircleArrowRight color="#015FEE" />
      </Icon>
      <Frame>
        <Stack spacing={1}>
          <Stack direction={"row"} spacing={2} alignItems={"center"}>
            <Stack border={"1px solid #00000015"} bgcolor={"#EFEFEF"} borderRadius={41} width={50} height={50} justifyContent={"center"} alignItems={"center"}>
              <img
                src={values?.organization?.isotype || values?.organization?.logo || "/placeholder.png"}
                alt="logo"
                width={35}
                onError={(e) => {
                  (e.target as HTMLImageElement).src = "/placeholder.png";
                }}
              />
            </Stack>
            <Stack>
              <Typography variant="h4">{values?.metaData?.title}</Typography>
              <Typography variant="body1">{values?.organization?.domain}</Typography>
            </Stack>
          </Stack>
          <Stack spacing={1}>
            <Typography variant="h3">{values?.metaData?.title}</Typography>
            <Typography variant="body1" color="text.secondary">
              {values?.metaData?.description ? values?.metaData?.description : ""}
            </Typography>
          </Stack>
        </Stack>
      </Frame>
    </Stack>
  );
};

export default WebsiteNavigation;
